import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import { SETTING_SECTIONS } from "./config/settings";
import RequireAuth from "./components/RequireAuth";
import { PermissionsProvider } from "./context/PermissionsContext";
import { SettingsProvider } from "./context/SettingsContext";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Employer = lazy(() => import("./pages/Employer"));
const Employee = lazy(() => import("./pages/Employee"));
const Orders = lazy(() => import("./pages/Orders"));
const Payments = lazy(() => import("./pages/Payments"));
const Complaints = lazy(() => import("./pages/Complaints"));
const Blacklist = lazy(() => import("./pages/Blacklist"));
const ActivityLog = lazy(() => import("./pages/ActivityLog"));
const SettingsOptionPage = lazy(() => import("./pages/settings/SettingsOptionPage"));
const Users = lazy(() => import("./pages/Users"));
const Roles = lazy(() => import("./pages/Roles"));
const Login = lazy(() => import("./pages/Login"));
const Reports = lazy(() => import("./pages/Reports"));

function PageLoader() {
  return (
    <div className="nexus-card p-8 text-center text-nexus-text-secondary animate-pulse">
      Loading…
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/*"
            element={
              <RequireAuth>
                <PermissionsProvider>
                  <SettingsProvider>
                  <Layout>
                    <Suspense fallback={<PageLoader />}>
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/employer" element={<Employer />} />
                        <Route path="/employee" element={<Employee />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/payments" element={<Payments />} />
                        <Route path="/complaints" element={<Complaints />} />
                        <Route path="/blacklist" element={<Blacklist />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/activity" element={<ActivityLog />} />
                        <Route path="/settings" element={<Navigate to="/settings/addresses" replace />} />
                        {SETTING_SECTIONS.map((section) => (
                          <Route
                            key={section.path}
                            path={section.path}
                            element={
                              <SettingsOptionPage
                                settingKey={section.key}
                                permissionKey={section.permissionKey}
                                title={section.title}
                                description={section.description}
                                itemLabel={section.itemLabel}
                              />
                            }
                          />
                        ))}
                        <Route path="/users" element={<Users />} />
                        <Route path="/roles" element={<Roles />} />
                        <Route path="/settings/users" element={<Navigate to="/users" replace />} />
                        <Route path="/settings/roles" element={<Navigate to="/roles" replace />} />
                      </Routes>
                    </Suspense>
                  </Layout>
                  </SettingsProvider>
                </PermissionsProvider>
              </RequireAuth>
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
